import styled from 'styled-components';

const CustomInput = styled.input`
  margin-right: 1rem;
  width: 1.6rem;
  height: 1.6rem;
  accent-color: var(--accent);
  cursor: pointer;
  flex: none;
`;

const Label = styled.label`
  font-size: 1.4rem;
  color: var(--ink-soft);
  cursor: pointer;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export { CustomInput, Label, InputContainer };
